import { PROPERTY_PURPOSE } from "properties/_models/PropertyMdl";
import { PropertiesStore } from "properties/_stores/propertiesStore";

const propertiesRentingStore = new PropertiesStore(PROPERTY_PURPOSE.RENT);
export { propertiesRentingStore };
